import { ERegistrationStep, ERegistrationStatus } from '../enums/ERegistrationSteps';

export const PROGRESS_STEP_MESSAGES = {
	[ERegistrationStep.BUSINESS]: {
		[ERegistrationStatus.PENDING]: 'Business registration pending',
		[ERegistrationStatus.IN_PROGRESS]: 'Business registration in progress...',
		[ERegistrationStatus.COMPLETED]: 'Business registration completed',
		[ERegistrationStatus.FAILED]: 'Business registration failed',
	},
	[ERegistrationStep.USER]: {
		[ERegistrationStatus.PENDING]: 'User creation pending',
		[ERegistrationStatus.IN_PROGRESS]: 'User creation in progress...',
		[ERegistrationStatus.COMPLETED]: 'User creation completed',
		[ERegistrationStatus.FAILED]: 'User creation failed',
	},
	[ERegistrationStep.CONFIGURING]: {
		[ERegistrationStatus.PENDING]: 'AI agent configuration pending',
		[ERegistrationStatus.IN_PROGRESS]: 'Configuring AI agent...',
		[ERegistrationStatus.COMPLETED]: 'AI agent configuration completed',
		[ERegistrationStatus.FAILED]: 'AI agent configuration failed',
	},
	[ERegistrationStep.FINALIZING]: {
		[ERegistrationStatus.PENDING]: 'Finalizing setup pending',
		[ERegistrationStatus.IN_PROGRESS]: 'Finalizing setup...',
		[ERegistrationStatus.COMPLETED]: 'Setup finalized successfully',
		[ERegistrationStatus.FAILED]: 'Setup finalization failed',
	},
} as const;

export const PROGRESS_STEP_STYLES = {
	dot: {
		[ERegistrationStatus.PENDING]: 'bg-gray-300',
		[ERegistrationStatus.IN_PROGRESS]: 'animate-pulse bg-blue-500',
		[ERegistrationStatus.COMPLETED]: 'bg-green-500',
		[ERegistrationStatus.FAILED]: 'bg-red-500',
	},
	text: {
		[ERegistrationStatus.PENDING]: 'text-gray-500',
		[ERegistrationStatus.IN_PROGRESS]: 'text-blue-600',
		[ERegistrationStatus.COMPLETED]: 'text-gray-700',
		[ERegistrationStatus.FAILED]: 'text-red-600',
	},
} as const;
